/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Why_MasksInputs */

const en_landing_why_masks = /** @type {(inputs: Landing_Why_MasksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masks`)
};

const zh_landing_why_masks = /** @type {(inputs: Landing_Why_MasksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`遮罩`)
};

/**
* | output |
* | --- |
* | "Masks" |
*
* @param {Landing_Why_MasksInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_why_masks = /** @type {((inputs?: Landing_Why_MasksInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Why_MasksInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_why_masks(inputs)
	return zh_landing_why_masks(inputs)
});
export { landing_why_masks as "landing.why.masks" }